import {
  ButtonERP,
  ButtonPrimeReact,
  PrimeReactModal,
} from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { MODAL_STYLES } from "constants/primereactStyles"
import { Button } from "primereact/button"
import { InputSwitch } from "primereact/inputswitch"
import { useState } from "react"
import { Trans, useTranslation } from "react-i18next"
import { INITIAL_MODAL_AUTORIZAR_STATE, stateAutorizar } from "../../constants"

const ModalAutorizar = ({
  showModalAutorizar,
  setShowModalAutorizar,
  handleImportarMovimientos,
}: {
  showModalAutorizar: stateAutorizar
  setShowModalAutorizar: React.Dispatch<React.SetStateAction<stateAutorizar>>
  handleImportarMovimientos: () => void
}) => {
  const { t } = useTranslation()
  const [showOptions, setShowOptions] = useState<boolean>(false)
  const handleOnHide = () => {
    setShowOptions(false)
    setShowModalAutorizar(INITIAL_MODAL_AUTORIZAR_STATE)
  }

  const handleSubmit = () => {
    handleImportarMovimientos()
    handleOnHide()
  }
  return (
    <PrimeReactModal
      visible={showModalAutorizar.status}
      baseZIndex={20}
      ptContext={MODAL_STYLES}
      closable={false}
      keepInViewport={false}
      header={
        <div className='tw-flex tw-justify-between tw-items-center tw-mb-6 tw-h-10'>
          <p className='tw-text-2xl tw-font-medium tw-text-primary tw-m-0'>
            {t("bancos.modal.vincularCuentaBancaria")}
          </p>
          <ButtonPrimeReact
            className='!tw-p-0 !tw-min-w-0 !tw-bg-white !tw-border-none !tw-text-black'
            onClick={handleOnHide}
          >
            <FontAwesomeIcon
              icon={["fal", "xmark"]}
              className='tw-w-5 tw-h-5'
            />
          </ButtonPrimeReact>
        </div>
      }
      className='!tw-w-128 tw-rounded-lg tw-py-6 tw-px-6 tw-bg-white'
    >
      <div className='tw-flex tw-flex-col'>
        <div className='tw-flex tw-flex-row tw-py-3 tw-pr-4 tw-pl-5 tw-border tw-rounded tw-bg-info-10 tw-border-info'>
          <FontAwesomeIcon
            icon={["fal", "lock-keyhole"]}
            className='!tw-h-5 !tw-mr-4 !tw-text-info'
          />
          <Trans
            i18nKey='bancos.modal.warningVincularCuenta'
            components={[
              <div
                className='tw-flex tw-flex-col [&>:nth-child(1)]:!tw-font-medium tw-text-info'
                key='0'
              >
                <span
                  className='tw-font-medium'
                  key='1'
                />
                <span key='2' />
              </div>,
            ]}
          />
        </div>
        <div className='tw-mt-6 tw-flex tw-flex-row tw-py-3 tw-pr-4 tw-pl-5 tw-border tw-rounded tw-bg-warning-10 tw-border-warning'>
          <FontAwesomeIcon
            icon={["fal", "triangle-exclamation"]}
            className='!tw-h-5 !tw-mr-4 !tw-text-warning'
          />
          <Trans
            i18nKey='bancos.modal.warningVincularCuenta1'
            components={[
              <div
                className='tw-flex tw-flex-col [&>:nth-child(1)]:!tw-font-medium tw-text-warning'
                key='0'
              />,
            ]}
          />
        </div>
        <div className='tw-flex tw-flex-col tw-mt-6'>
          <span
            className='tw-flex tw-flex-row tw-items-center tw-justify-between tw-mb-4 tw-cursor-pointer'
            onClick={() => setShowOptions(!showOptions)}
          >
            <p className='tw-font-medium tw-text-lg'>
              {t("bancos.modal.selectedSincronizar")}
            </p>
            <span className='tw-w-10 tw-h-10 tw-flex tw-flex-row tw-items-center tw-justify-center'>
              <FontAwesomeIcon
                icon={["fal", showOptions ? "angle-right" : "angle-down"]}
                className='tw-w-3.5'
              />
            </span>
          </span>
          {showOptions && (
            <div className='tw-flex tw-flex-col'>
              <div className='tw-flex tw-flex-row tw-justify-between tw-items-center tw-mb-11'>
                <div className='tw-flex tw-flex-row tw-items-center'>
                  <p className='tw-text-lg tw-mb-0'>
                    {t("bancos.modal.movimientosLabel")}
                  </p>
                  <Button
                    className='!tw-w-fit !tw-h-fit !tw-p-0 !tw-bg-transparent !tw-border-transparent'
                    tooltip={`${t("bancos.modal.tooltipMovimientos")}`}
                  >
                    <FontAwesomeIcon
                      icon={["fal", "circle-info"]}
                      className='!tw-ml-2 !tw-h-5 !tw-w-5 tw-text-info'
                    />
                  </Button>
                </div>
                <InputSwitch
                  checked={showModalAutorizar.movimientos}
                  onChange={() =>
                    setShowModalAutorizar((prevState: stateAutorizar) => ({
                      ...prevState,
                      movimientos: !prevState.movimientos,
                    }))
                  }
                />
              </div>
            </div>
          )}
        </div>
        <div className='tw-flex tw-flex-row tw-justify-end tw-items-center tw-gap-4'>
          <ButtonERP
            customize={{
              type: "white",
              size: "md",
            }}
            onClick={handleOnHide}
            label={`${t("bancos.modal.cancel")}`}
          />
          <ButtonERP
            customize={{
              type: "primary",
              size: "md",
            }}
            onClick={handleSubmit}
            label={`${t("bancos.modal.continuar")}`}
          />
        </div>
      </div>
    </PrimeReactModal>
  )
}

export default ModalAutorizar
